// @flow
import { getCreator, postCreator } from '../../../http/index';
import environment from '../../../environment/index';

export const endpoints = Object.freeze({
  FETCH_SESSION: `${environment.apiUrl}/auth/session`,
  RESEND_VERIFICATION: `${environment.apiUrl}/auth/send-verification`,
  SEND_FORGOT_PASSWORD: `${environment.apiUrl}/auth/recovery`,
  RECOVER_USER: `${environment.apiUrl}/auth/recovery/recover`,
});

export const fetchSessionApi = getCreator(fetch, endpoints.FETCH_SESSION);
export const postResendVerificationApi = postCreator(fetch, endpoints.RESEND_VERIFICATION);
export const postSendForgotPasswordApi = postCreator(fetch, endpoints.SEND_FORGOT_PASSWORD);
export const postRecoverUserApi = postCreator(fetch, endpoints.RECOVER_USER);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/api.js